import React, { useEffect, useState } from "react";
import axios from "axios";
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  ArcElement
);

const IncidentConsequences = () => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/healthAndSafetyJson`);
        const rawData = response.data.data.Data.filter(item => typeof item["__EMPTY"] === "number");

        // Process data for multi-series pie chart
        const consequences = rawData.map(item => item["__EMPTY_6"]);
        const absences = rawData.map(item => item["__EMPTY_7"]);
        const costs = rawData.map(item => item["__EMPTY_8"]);

        const uniqueConsequences = [...new Set(consequences)];

        // Aggregate data
        const aggregateData = (consequence, dataArray) => {
          return uniqueConsequences.map(unique => {
            return dataArray
              .filter((_, idx) => consequences[idx] === unique)
              .reduce((acc, val) => acc + val, 0);
          });
        };

        const dataAbsences = aggregateData(uniqueConsequences, absences);
        const dataCosts = aggregateData(uniqueConsequences, costs);

        setChartData({
          labels: uniqueConsequences,
          datasets: [
            {
              label: 'Days of Absence',
              data: dataAbsences,
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
            {
              label: 'Incident Costs',
              data: dataCosts,
              backgroundColor: 'rgba(255, 99, 132, 0.6)',
              borderColor: 'rgba(255, 99, 132, 1)',
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) return <div>Error: {error.message}</div>;
  if (!chartData) return (
    <Container sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <CircularProgress />
    </Container>
  );

  return (
    <div>
      <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
        <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
          Days of Absence and Incident Costs by Injury Consequence
        </Typography>
      </Box>
      <Container>
        <div style={{ padding: "20px", width: "100%", height: "80%" }}>
          <Doughnut
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                legend: { display: true, position: 'top' },
                tooltip: {
                  callbacks: {
                    label: context => `${context.dataset.label}: ${context.raw}`
                  }
                }
              },
              animation: {
                duration: 2000, // duration of animations in milliseconds
                loop: true, // makes the animation loop
              },
            }}
          />
        </div>
      </Container>
    </div>
  );
};

export default IncidentConsequences;
